export function isRedirectionForDocs (redirect) {
  return redirect.includes('docs.thunderstock.ai') || redirect.includes('/docs')
}

// Redirect to docs, this could be a full URL or /docs that will be redirected to https://docs.thunderstock.ai
export function redirectToDocs (redirect) {
  const refreshToken = encodeURIComponent(localStorage.getItem('refresh_token'))
  if (!refreshToken) {
    console.error('No refresh token found for redirection to docs, cannot proceed with redirection.')
    return
  }
  if (redirect?.includes('docs.thunderstock.ai')) {
    window.location.href = redirect + `?refresh_token=${refreshToken}`
  } else {
    window.location.href = `https://docs.thunderstock.ai/?refresh_token=${refreshToken}`
  }
}
